export default __webpack_public_path__ + "static/media/resume.db7f3f24.pdf";